import { render, staticRenderFns } from "./ListExceptionsOVG.vue?vue&type=template&id=0ba0c1ba&scoped=true&lang=pug"
import script from "./ListExceptionsOVG.vue?vue&type=script&lang=js"
export * from "./ListExceptionsOVG.vue?vue&type=script&lang=js"
import style0 from "./ListExceptionsOVG.vue?vue&type=style&index=0&id=0ba0c1ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba0c1ba",
  null
  
)

export default component.exports